// import DefaultLayout from "@/layouts/Default";
// import Login from "@/views/login/login";
import DefaultLayout from "./layouts/Default";
import Login from "./views/login/login";
import Home from "./views/home/home";
import Forget from "./views/login/forget";
import Privacy from "./views/privacy/privacy";
import WebTerm from "./views/web-term/web-term";

const RoutePaths = [
    {
        path:'/:eDepartmentId',
        layout: DefaultLayout,
        component: Login
    },
    {
        path:'/:eDepartmentId/login',
        layout: DefaultLayout,
        component: Login
    },
    {
        path:'/:eDepartmentId/home',
        layout: DefaultLayout,
        component: Home
    },
    {
        path:'/:eDepartmentId/forget',
        layout: DefaultLayout,
        component: Forget
    },
    {
        path:'/:eDepartmentId/privacy',
        layout: DefaultLayout,
        component: Privacy
    },
    {
        path:'/:eDepartmentId/term',
        layout: DefaultLayout,
        component: WebTerm
    }
]

export default RoutePaths;